/* @flow weak */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'LOAD_PAYMENT_ACCOUNT',
  'PATCH_PAYMENT_ACCOUNT',
  'WITHDRAW_MONEY',
]);



// WEBPACK FOOTER //
// ./src/payments/constants/PaymentAccountConstants.js